var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item)?_c('v-chip',{staticClass:"white--text",attrs:{"x-small":"","color":_vm.get_color(_vm.item),"label":""}},[_vm._v(_vm._s(_vm.item.attendence == "P" ? "P" : _vm.item.attendence)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }